import { vars } from 'nativewind';

export const nativewindThemes = { 
  default: {
    light: {
      '--color-primary-50': '251 242 244',
      '--color-primary-100': '247 230 233',
      '--color-primary-200': '241 204 211',
      '--color-primary-300': '235 179 189',
      '--color-primary-400': '229 153 167',
      '--color-primary-500': '216 63 96',
      '--color-primary-600': '173 50 77',
      '--color-primary-700': '130 38 58',
      '--color-primary-800': '86 25 38',
      '--color-primary-900': '43 13 19',
      '--color-primary-950': '22 6 10',
      '--color-secondary-50': '246 246 246',
      '--color-secondary-100': '237 237 237',
      '--color-secondary-200': '219 219 219',
      '--color-secondary-300': '201 201 201',
      '--color-secondary-400': '183 183 183',
      '--color-secondary-500': '51 51 51',
      '--color-secondary-600': '41 41 41',
      '--color-secondary-700': '31 31 31',
      '--color-secondary-800': '20 20 20',
      '--color-secondary-900': '10 10 10',
      '--color-secondary-950': '5 5 5',
      '--color-tertiary-50': '238 242 255',
      '--color-tertiary-100': '224 231 255',
      '--color-tertiary-200': '199 210 254',
      '--color-tertiary-300': '165 180 252',
      '--color-tertiary-400': '129 140 248',
      '--color-tertiary-500': '99 102 241',
      '--color-tertiary-600': '79 70 229',
      '--color-tertiary-700': '67 56 202',
      '--color-tertiary-800': '55 48 163',
      '--color-tertiary-900': '49 46 129',
      '--color-tertiary-950': '30 27 75',
    },
    dark: {
      '--color-primary-50': '22 6 10',
      '--color-primary-100': '43 13 19',
      '--color-primary-200': '86 25 38',
      '--color-primary-300': '130 38 58',
      '--color-primary-400': '173 50 77',
      '--color-primary-500': '216 63 96',
      '--color-primary-600': '229 153 167',
      '--color-primary-700': '235 179 189',
      '--color-primary-800': '241 204 211',
      '--color-primary-900': '247 230 233',
      '--color-primary-950': '251 242 244',
      '--color-secondary-50': '5 5 5',
      '--color-secondary-100': '10 10 10',
      '--color-secondary-200': '20 20 20',
      '--color-secondary-300': '31 31 31',
      '--color-secondary-400': '41 41 41',
      '--color-secondary-500': '51 51 51',
      '--color-secondary-600': '183 183 183',
      '--color-secondary-700': '201 201 201',
      '--color-secondary-800': '219 219 219',
      '--color-secondary-900': '237 237 237',
      '--color-secondary-950': '246 246 246',
      '--color-tertiary-50': '30 27 75',
      '--color-tertiary-100': '49 46 129',
      '--color-tertiary-200': '55 48 163',
      '--color-tertiary-300': '67 56 202',
      '--color-tertiary-400': '79 70 229',
      '--color-tertiary-500': '99 102 241',
      '--color-tertiary-600': '129 140 248',
      '--color-tertiary-700': '165 180 252',
      '--color-tertiary-800': '199 210 254',
      '--color-tertiary-900': '224 231 255',
      '--color-tertiary-950': '238 242 255',
    },
  },
  grommr: {
    light: {
      '--color-primary-50': '247 249 242',
      '--color-primary-100': '238 243 229',
      '--color-primary-200': '215 224 198',
      '--color-primary-300': '192 205 167',
      '--color-primary-400': '169 186 136',
      '--color-primary-500': '134 160 71',  // was #6D5F49, now #86A047
      '--color-primary-600': '107 128 57',
      '--color-primary-700': '80 96 43',
      '--color-primary-800': '54 64 29',
      '--color-primary-900': '27 32 14',
      '--color-primary-950': '13 16 7',
      '--color-secondary-50': '247 245 242',
      '--color-secondary-100': '235 231 226',
      '--color-secondary-200': '207 199 188',
      '--color-secondary-300': '179 167 150',
      '--color-secondary-400': '151 135 112',
      '--color-secondary-500': '109 95 73',  // was #86A047, now #6D5F49
      '--color-secondary-600': '87 76 58',
      '--color-secondary-700': '65 57 44',
      '--color-secondary-800': '44 38 29',
      '--color-secondary-900': '22 19 15',
      '--color-secondary-950': '11 10 7',
      '--color-tertiary-50': '241 245 249',
      '--color-tertiary-100': '227 236 242',
      '--color-tertiary-200': '200 217 230',
      '--color-tertiary-300': '172 198 217',
      '--color-tertiary-400': '145 179 204',
      '--color-tertiary-500': '93 143 180',  // #5D8FB4
      '--color-tertiary-600': '74 114 144',
      '--color-tertiary-700': '56 86 108',
      '--color-tertiary-800': '37 57 72',
      '--color-tertiary-900': '19 29 36',
      '--color-tertiary-950': '9 14 18',
    },
    dark: {
      '--color-primary-50': '13 16 7',
      '--color-primary-100': '27 32 14',
      '--color-primary-200': '54 64 29',
      '--color-primary-300': '80 96 43',
      '--color-primary-400': '107 128 57',
      '--color-primary-500': '134 160 71',
      '--color-primary-600': '169 186 136',
      '--color-primary-700': '192 205 167',
      '--color-primary-800': '215 224 198',
      '--color-primary-900': '238 243 229',
      '--color-primary-950': '247 249 242',
      '--color-secondary-50': '11 10 7',
      '--color-secondary-100': '22 19 15',
      '--color-secondary-200': '44 38 29',
      '--color-secondary-300': '65 57 44',
      '--color-secondary-400': '87 76 58',
      '--color-secondary-500': '109 95 73',
      '--color-secondary-600': '151 135 112',
      '--color-secondary-700': '179 167 150',
      '--color-secondary-800': '207 199 188',
      '--color-secondary-900': '235 231 226',
      '--color-secondary-950': '247 245 242',
      '--color-tertiary-50': '9 14 18',
      '--color-tertiary-100': '19 29 36',
      '--color-tertiary-200': '37 57 72',
      '--color-tertiary-300': '56 86 108',
      '--color-tertiary-400': '74 114 144',
      '--color-tertiary-500': '93 143 180',  // #5D8FB4
      '--color-tertiary-600': '145 179 204',
      '--color-tertiary-700': '172 198 217',
      '--color-tertiary-800': '200 217 230',
      '--color-tertiary-900': '227 236 242',
      '--color-tertiary-950': '241 245 249',
    },
  },
  feabie: {
    light: {
      '--color-primary-50': '253 244 241',
      '--color-primary-100': '250 233 227',
      '--color-primary-200': '245 211 199',
      '--color-primary-300': '240 189 171',
      '--color-primary-400': '235 167 143',
      '--color-primary-500': '228 148 67',  // was #df5f49, now #e49443
      '--color-primary-600': '182 118 54',
      '--color-primary-700': '137 89 40',
      '--color-primary-800': '91 59 27',
      '--color-primary-900': '46 30 13',
      '--color-primary-950': '23 15 7',
      '--color-secondary-50': '252 243 242',
      '--color-secondary-100': '249 231 229',
      '--color-secondary-200': '243 207 203',
      '--color-secondary-300': '237 183 177',
      '--color-secondary-400': '231 159 151',
      '--color-secondary-500': '223 95 73',  // was #e49443, now #df5f49
      '--color-secondary-600': '178 76 58',
      '--color-secondary-700': '134 57 44',
      '--color-secondary-800': '89 38 29',
      '--color-secondary-900': '45 19 15',
      '--color-secondary-950': '22 10 7',
      '--color-tertiary-50': '238 248 241',
      '--color-tertiary-100': '220 240 227',
      '--color-tertiary-200': '185 225 199',
      '--color-tertiary-300': '150 210 170',
      '--color-tertiary-400': '115 195 142',
      '--color-tertiary-500': '49 167 89',  // #31A759
      '--color-tertiary-600': '39 134 71',
      '--color-tertiary-700': '29 100 53',
      '--color-tertiary-800': '20 67 36',
      '--color-tertiary-900': '10 33 18',
      '--color-tertiary-950': '5 17 9',
    },
    dark: {
      '--color-primary-50': '23 15 7',
      '--color-primary-100': '46 30 13',
      '--color-primary-200': '91 59 27',
      '--color-primary-300': '137 89 40',
      '--color-primary-400': '182 118 54',
      '--color-primary-500': '228 148 67',
      '--color-primary-600': '235 167 143',
      '--color-primary-700': '240 189 171',
      '--color-primary-800': '245 211 199',
      '--color-primary-900': '250 233 227',
      '--color-primary-950': '253 244 241',
      '--color-secondary-50': '22 10 7',
      '--color-secondary-100': '45 19 15',
      '--color-secondary-200': '89 38 29',
      '--color-secondary-300': '134 57 44',
      '--color-secondary-400': '178 76 58',
      '--color-secondary-500': '223 95 73',
      '--color-secondary-600': '231 159 151',
      '--color-secondary-700': '237 183 177',
      '--color-secondary-800': '243 207 203',
      '--color-secondary-900': '249 231 229',
      '--color-secondary-950': '252 243 242',
      '--color-tertiary-50': '5 17 9',
      '--color-tertiary-100': '10 33 18',
      '--color-tertiary-200': '20 67 36',
      '--color-tertiary-300': '29 100 53',
      '--color-tertiary-400': '39 134 71',
      '--color-tertiary-500': '49 167 89',  // #31A759
      '--color-tertiary-600': '115 195 142',
      '--color-tertiary-700': '150 210 170',
      '--color-tertiary-800': '185 225 199',
      '--color-tertiary-900': '220 240 227',
      '--color-tertiary-950': '238 248 241',
    },
  },
  chasabl: {
    light: {
      '--color-primary-50': '242 248 248',
      '--color-primary-100': '229 241 240',
      '--color-primary-200': '203 227 225',
      '--color-primary-300': '177 213 210',
      '--color-primary-400': '151 199 195',
      '--color-primary-500': '102 154 152',  // was #473C3A, now #669A98
      '--color-primary-600': '82 123 122',
      '--color-primary-700': '61 92 91',
      '--color-primary-800': '41 62 61',
      '--color-primary-900': '20 31 30',
      '--color-primary-950': '10 15 15',
      '--color-secondary-50': '242 241 241',
      '--color-secondary-100': '229 227 227',
      '--color-secondary-200': '203 199 198',
      '--color-secondary-300': '177 171 169',
      '--color-secondary-400': '151 143 140',
      '--color-secondary-500': '71 60 58',  // was #669A98, now #473C3A
      '--color-secondary-600': '57 48 46',
      '--color-secondary-700': '43 36 35',
      '--color-secondary-800': '29 24 23',
      '--color-secondary-900': '14 12 12',
      '--color-secondary-950': '7 6 6',
      '--color-tertiary-50': '251 245 240',
      '--color-tertiary-100': '248 235 224',
      '--color-tertiary-200': '240 214 194',
      '--color-tertiary-300': '233 194 163',
      '--color-tertiary-400': '226 173 132',
      '--color-tertiary-500': '212 135 74',  // #D4874A - softened from #F97316
      '--color-tertiary-600': '170 108 59',
      '--color-tertiary-700': '127 81 44',
      '--color-tertiary-800': '85 54 30',
      '--color-tertiary-900': '42 27 15',
      '--color-tertiary-950': '21 14 7',
    },
    dark: {
      '--color-primary-50': '10 15 15',
      '--color-primary-100': '20 31 30',
      '--color-primary-200': '41 62 61',
      '--color-primary-300': '61 92 91',
      '--color-primary-400': '82 123 122',
      '--color-primary-500': '102 154 152',
      '--color-primary-600': '151 199 195',
      '--color-primary-700': '177 213 210',
      '--color-primary-800': '203 227 225',
      '--color-primary-900': '229 241 240',
      '--color-primary-950': '242 248 248',
      '--color-secondary-50': '7 6 6',
      '--color-secondary-100': '14 12 12',
      '--color-secondary-200': '29 24 23',
      '--color-secondary-300': '43 36 35',
      '--color-secondary-400': '57 48 46',
      '--color-secondary-500': '71 60 58',
      '--color-secondary-600': '151 143 140',
      '--color-secondary-700': '177 171 169',
      '--color-secondary-800': '203 199 198',
      '--color-secondary-900': '229 227 227',
      '--color-secondary-950': '242 241 241',
      '--color-tertiary-50': '21 14 7',
      '--color-tertiary-100': '42 27 15',
      '--color-tertiary-200': '85 54 30',
      '--color-tertiary-300': '127 81 44',
      '--color-tertiary-400': '170 108 59',
      '--color-tertiary-500': '212 135 74',  // #D4874A - softened from #F97316
      '--color-tertiary-600': '226 173 132',
      '--color-tertiary-700': '233 194 163',
      '--color-tertiary-800': '240 214 194',
      '--color-tertiary-900': '248 235 224',
      '--color-tertiary-950': '251 245 240',
    },
  },
  ferzu: {
    light: {
      '--color-primary-50': '253 244 241',
      '--color-primary-100': '251 233 227',
      '--color-primary-200': '247 211 199',
      '--color-primary-300': '243 189 171',
      '--color-primary-400': '240 167 143',
      '--color-primary-500': '240 121 55',  // was #15b9d5, now #f07937
      '--color-primary-600': '192 97 44',
      '--color-primary-700': '144 73 33',
      '--color-primary-800': '96 49 22',
      '--color-primary-900': '48 24 11',
      '--color-primary-950': '24 12 6',
      '--color-secondary-50': '240 249 251',
      '--color-secondary-100': '225 243 247',
      '--color-secondary-200': '195 231 239',
      '--color-secondary-300': '165 219 231',
      '--color-secondary-400': '135 207 223',
      '--color-secondary-500': '21 185 213',  // was #f07937, now #15b9d5
      '--color-secondary-600': '17 148 170',
      '--color-secondary-700': '13 111 128',
      '--color-secondary-800': '8 74 85',
      '--color-secondary-900': '4 37 43',
      '--color-secondary-950': '2 19 21',
      '--color-tertiary-50': '253 240 238',
      '--color-tertiary-100': '251 224 221',
      '--color-tertiary-200': '248 194 186',
      '--color-tertiary-300': '244 163 152',
      '--color-tertiary-400': '241 132 118',
      '--color-tertiary-500': '234 74 53',  // #EA4A35
      '--color-tertiary-600': '187 59 42',
      '--color-tertiary-700': '140 44 32',
      '--color-tertiary-800': '94 30 21',
      '--color-tertiary-900': '47 15 11',
      '--color-tertiary-950': '23 7 5',
    },
    dark: {
      '--color-primary-50': '24 12 6',
      '--color-primary-100': '48 24 11',
      '--color-primary-200': '96 49 22',
      '--color-primary-300': '144 73 33',
      '--color-primary-400': '192 97 44',
      '--color-primary-500': '240 121 55',
      '--color-primary-600': '240 167 143',
      '--color-primary-700': '243 189 171',
      '--color-primary-800': '247 211 199',
      '--color-primary-900': '251 233 227',
      '--color-primary-950': '253 244 241',
      '--color-secondary-50': '2 19 21',
      '--color-secondary-100': '4 37 43',
      '--color-secondary-200': '8 74 85',
      '--color-secondary-300': '13 111 128',
      '--color-secondary-400': '17 148 170',
      '--color-secondary-500': '21 185 213',
      '--color-secondary-600': '135 207 223',
      '--color-secondary-700': '165 219 231',
      '--color-secondary-800': '195 231 239',
      '--color-secondary-900': '225 243 247',
      '--color-secondary-950': '240 249 251',
      '--color-tertiary-50': '23 7 5',
      '--color-tertiary-100': '47 15 11',
      '--color-tertiary-200': '94 30 21',
      '--color-tertiary-300': '140 44 32',
      '--color-tertiary-400': '187 59 42',
      '--color-tertiary-500': '234 74 53',  // #EA4A35
      '--color-tertiary-600': '241 132 118',
      '--color-tertiary-700': '244 163 152',
      '--color-tertiary-800': '248 194 186',
      '--color-tertiary-900': '251 224 221',
      '--color-tertiary-950': '253 240 238',
    },
  },
  pupspace: {
    light: {
      '--color-primary-50': '253 241 241',
      '--color-primary-100': '251 227 227',
      '--color-primary-200': '247 199 199',
      '--color-primary-300': '243 171 171',
      '--color-primary-400': '239 143 143',
      '--color-primary-500': '238 27 38',  // was #1B1B1D, now #EE1B26
      '--color-primary-600': '190 22 30',
      '--color-primary-700': '143 16 23',
      '--color-primary-800': '95 11 15',
      '--color-primary-900': '48 5 8',
      '--color-primary-950': '24 3 4',
      '--color-secondary-50': '248 248 250',
      '--color-secondary-100': '232 232 235',
      '--color-secondary-200': '198 198 202',
      '--color-secondary-300': '156 156 161',
      '--color-secondary-400': '104 104 109',
      '--color-secondary-500': '48 48 52',
      '--color-secondary-600': '38 38 42',
      '--color-secondary-700': '29 29 32',
      '--color-secondary-800': '20 20 22',
      '--color-secondary-900': '13 13 14',
      '--color-secondary-950': '9 9 10',
      '--color-tertiary-50': '233 247 255',
      '--color-tertiary-100': '212 240 254',
      '--color-tertiary-200': '168 225 254',
      '--color-tertiary-300': '125 210 253',
      '--color-tertiary-400': '82 195 252',
      '--color-tertiary-500': '0 166 251',  // #00A6FB
      '--color-tertiary-600': '0 133 201',
      '--color-tertiary-700': '0 100 151',
      '--color-tertiary-800': '0 66 100',
      '--color-tertiary-900': '0 33 50',
      '--color-tertiary-950': '0 17 25',
    },
    dark: {
      '--color-primary-50': '24 3 4',
      '--color-primary-100': '48 5 8',
      '--color-primary-200': '95 11 15',
      '--color-primary-300': '143 16 23',
      '--color-primary-400': '190 22 30',
      '--color-primary-500': '238 27 38',
      '--color-primary-600': '239 143 143',
      '--color-primary-700': '243 171 171',
      '--color-primary-800': '247 199 199',
      '--color-primary-900': '251 227 227',
      '--color-primary-950': '253 241 241',
      '--color-secondary-50': '9 9 10',
      '--color-secondary-100': '13 13 14',
      '--color-secondary-200': '20 20 22',
      '--color-secondary-300': '29 29 32',
      '--color-secondary-400': '38 38 42',
      '--color-secondary-500': '48 48 52',
      '--color-secondary-600': '104 104 109',
      '--color-secondary-700': '156 156 161',
      '--color-secondary-800': '198 198 202',
      '--color-secondary-900': '232 232 235',
      '--color-secondary-950': '248 248 250',
      '--color-tertiary-50': '0 17 25',
      '--color-tertiary-100': '0 33 50',
      '--color-tertiary-200': '0 66 100',
      '--color-tertiary-300': '0 100 151',
      '--color-tertiary-400': '0 133 201',
      '--color-tertiary-500': '0 166 251',  // #00A6FB
      '--color-tertiary-600': '82 195 252',
      '--color-tertiary-700': '125 210 253',
      '--color-tertiary-800': '168 225 254',
      '--color-tertiary-900': '212 240 254',
      '--color-tertiary-950': '233 247 255',
    },
  },
};

// Locally-scoped theme vars (NativeWind vars cascade), one stable object per
// theme x color scheme, built once at module load. Screens that must render
// in a specific community's branding without touching the global theme
// (community previews, sign-in, legacy account pages) wrap themselves in
// these — the global theme keeps a single owner, ThemeProvider's
// currentCommunity derivation.
export const themeScopeVars = Object.fromEntries(
  Object.entries(nativewindThemes).map(([name, schemes]) => [
    name,
    { light: vars(schemes.light), dark: vars(schemes.dark) },
  ])
) as Record<
  keyof typeof nativewindThemes,
  { light: ReturnType<typeof vars>; dark: ReturnType<typeof vars> }
>;
